import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeRo from '@angular/common/locales/ro';
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { APIRouteMap } from '@core/models/api';
import { AuthService, LangService } from '@core/services';
import {
  imageInterceptor,
  INTERCEPTOR_CONFIG,
  langInitializer,
} from '@core/utils';
import { environment } from '@environment';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  AUTH_SERVICE,
  baseUrlInterceptor,
  errorInterceptor,
  jwtInterceptor,
  LANG_SERVICE,
  langInterceptor,
  loggingInterceptor,
  TOKEN_SERVICE,
  TokenService,
} from '@paypoint-frontend/web-core';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import {
  BsDatepickerConfig,
  BsDatepickerModule,
} from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { routes } from './app.routes';

registerLocaleData(localeRo);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: AUTH_SERVICE, useExisting: AuthService },
    { provide: TOKEN_SERVICE, useExisting: TokenService },
    { provide: LANG_SERVICE, useExisting: LangService },
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([
        baseUrlInterceptor(environment),
        errorInterceptor,
        jwtInterceptor(INTERCEPTOR_CONFIG.jwtInterceptor.skipUrls),
        langInterceptor('ro', INTERCEPTOR_CONFIG.langInterceptor.skipUrls),
        loggingInterceptor,
        imageInterceptor(),
      ]),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: `${APIRouteMap.CONTENT_GETTRANSLATES}/`,
        suffix: `${APIRouteMap.CONTENT_GETTRANSLATES_SUFFIX}`,
      }),
    }),
    importProvidersFrom([
      TooltipModule.forRoot(),
      BsDatepickerModule.forRoot(),
    ]),
    {
      provide: BsDatepickerConfig,
      useFactory: () => {
        const config = new BsDatepickerConfig();
        config.dateInputFormat = 'DD.MM.YYYY'; // Формат даты
        config.showWeekNumbers = false;
        return config;
      },
    },
    provideAppInitializer(langInitializer),
    provideAnimationsAsync(),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey,
    },
    {
      provide: LOCALE_ID,
      useValue: 'ro-RO',
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'dd.MM.yyyy' },
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: false,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
